export class YalwaRadioBase extends HTMLElement {
	
	constructor() {
		super();
		if (!this.shadowRoot) {
			this.attachShadow({mode: 'open'});
		}
	}
	
	upgrade_properties(props) {
		props.forEach(prop => {
			if (this.hasOwnProperty(prop)) {
				const val = this[prop];
				delete this[prop];
				this[prop] = val;
			}
		});
	}
	
	async load_css(css_text) {
		try {
			await yalwa.basics.check_stylesheet_polyfill_needed();
			const sheet = new CSSStyleSheet();
			sheet.replaceSync(css_text);
			this.shadowRoot.adoptedStyleSheets = [sheet];
			jQuery(this).removeClass('invisible');
		} catch (e) {
			console.error('Failed to load radio CSS', e);
		}
	}
	
	get mark_required() {
		return this.hasAttribute('mark_required');
	}
	set mark_required(v) {
		if (v) {
			this.setAttribute('mark_required', '');
		} else {
			this.removeAttribute('mark_required');
		}
	}
}